import { getMykissEnv } from './getMykissEnv';

export function isDevelopment(): boolean {
  return getMykissEnv() === 'development';
}
